// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Дописи в соцмережах» (Social posts, ключ `social`, група `communications`). */
export const socialPostsManifest: IModuleManifest = {
  key: 'social',
  group: 'communications',
  slug: 'social-posts',
  prefix: 'SOC',
  name: { en: 'Social posts', uk: 'Дописи в соцмережах' },
  entities: [
    { key: 'social', slug: 'social', name: { en: 'Social posts', uk: 'Дописи в соцмережах' }, main: true },
    { key: 'post_channel', slug: 'post-channel', name: { en: 'Post Channels', uk: 'Канали' }, main: false },
    { key: 'post_approval', slug: 'post-approval', name: { en: 'Post Approvals', uk: 'Погодження' }, main: false },
    { key: 'post_result', slug: 'post-result', name: { en: 'Post Results', uk: 'Результати' }, main: false },
    { key: 'post_campaign', slug: 'post-campaign', name: { en: 'Post Campaigns', uk: 'Кампанії' }, main: false },
    { key: 'post_status', slug: 'post-status', name: { en: 'Post Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/socialPostsSlice').then((m) => m.socialPostsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
